import { DROPDOWN_VARIANT, DROPDOWN_ANCHOR } from '../Dropdown';

export const SELECT_VARIANT = DROPDOWN_VARIANT;

export const SELECT_ANCHOR = DROPDOWN_ANCHOR;

export const SELECT_ALL_OPTION_VALUE = 'all';
